t = require('views/internal/teacup-with-helpers')('member_profile_info')
memberTemplate = require './member'

module.exports = ->
  t.div '.member-profile-info.u-clearfix', { name: t.mustacheVar('username') }, ->

    t.div '.member', ->
      memberTemplate t.mustacheVar('.')

    t.div '.info', ->

      t.h3 '.u-bottom', ->
        t.a '.js-profile', { href: '/' + t.mustacheVar('username') }, ->
          t.text t.mustacheVar('fullName')

      t.p '.quiet.u-bottom', ->
        t.format 'at-username', { username: t.mustacheVar('username') }
      t.mustacheBlock 'bio', ->
        t.p '.member-profile-info-bio.quiet', { title: t.mustacheVar('bio') }, ->
          t.raw t.mustacheVar('bioHtml')
      t.p '.quiet.u-bottom', ->
        t.mustacheBlock 'showMemberOptions', ->
          t.mustacheBlock 'orgCardsUrl', ->
            t.a { href: t.mustacheVar('orgCardsUrl') }, ->
              t.format 'view-org-cards'
          t.mustacheBlock '__ed', ->
            t.span ->
              t.a '.js-remove-mem', { href: '#' }, ->
                t.format 'remove-from-org'




// WEBPACK FOOTER //
// ./app/scripts/views/templates/member_profile_info.coffee